exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".permissions-configurer .delete-permissions {\n  padding-top: 7px;\n}\n.permissions-configurer .permissions-row {\n  margin-bottom: 3px;\n}\n.permissions-configurer .permissions-group {\n  padding-left: 0;\n}\n.permissions-configurer .add-new:hover,\n.permissions-configurer .add-new:focus,\n.permissions-configurer .add-new:active {\n  background-color: transparent;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib!./node_modules/less-loader/dist/cjs.js!./app/scripts/modules/core/src/application/modal/PermissionsConfigurer.less
// module id = 2794
// module chunks = 0